import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import Swal from 'sweetalert2';
import pluralize from "pluralize";

import './api';
import '../../sass/pcm/app.scss';
import FileWorkerQueueHandler from "@/pcm/classes/FileWorkerQueueHandler";

window.Swal = Swal;
window.pluralize = pluralize;

window.FileWorkerQueueHandler = new FileWorkerQueueHandler();

window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: 'reverb',
    key: window.global.reverb.key,
    wsHost: window.global.reverb.host,
    wsPort: window.global.reverb.port,
    wssPort: window.global.reverb.port,
    forceTLS: (window.global.reverb.scheme ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
    authorizer: (channel, options) => {
        return {
            authorize: (socketId, callback) => {
                window.axios.post('/api/broadcasting/auth', {
                    socket_id: socketId,
                    channel_name: channel.name
                })
                    .then(response => {
                        callback(false, response.data);
                    })
                    .catch(error => {
                        callback(true, error);
                    });
            }
        };
    },
});
